import {
  ActionReducerMapBuilder,
  createSlice,
  PayloadAction,
  SliceCaseReducers,
} from "@reduxjs/toolkit";
import { asyncMutations, mutationBuilder } from "./remoteAccess.mutations";

export interface State {
  open: boolean;
  loading: boolean;
  peerId: string | null;
  waitingFor: string;
}

interface Actions extends SliceCaseReducers<State> {
  setRemoteAccessOpen: (state: State, action: PayloadAction<{ open: boolean }>) => State;
  setPeerId: (state: State, action: PayloadAction<{ peerId: string | null }>) => State;
  setWaitingFor: (state: State, action: PayloadAction<{ waitingFor: string }>) => State;
}

//interface Selectors {}

export const initialState: State = {
  open: false,
  loading: false,
  peerId: null,
  waitingFor: "",
};

const actions: Actions = {
  setRemoteAccessOpen: (state, { payload: { open } }) => {
    state.open = open;
    return state;
  },
  setPeerId: (state, { payload: { peerId } }) => {
    state.peerId = peerId;
    return state;
  },
  setWaitingFor: (state, { payload: { waitingFor } }) => {
    state.waitingFor = waitingFor;
    return state;
  },
};

//const selectors: Selectors = {};

const storeBase = createSlice<State, Actions>({
  name: "stock",
  initialState,
  reducers: actions,
  extraReducers: (builder: ActionReducerMapBuilder<State>) => {
    mutationBuilder(builder);
  },
});

export default storeBase.reducer;
export const { setRemoteAccessOpen, setPeerId, setWaitingFor } = storeBase.actions;
export const { sendRemoteAccessEmail } = asyncMutations;
